import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  AcceptCommercialAgreementTemplateRequest,
  AmendCommercialAgreementTemplateRequest,
  CreateCommercialAgreementTemplatePdfPreviewRequest,
} from '@/types/requests/commercial-agreement-templates'
import { CommercialAgreementTemplateItem } from '@/types/responses/commercial-agreement-templates'

class CommercialAgreementTemplateService {
  private endpoint = `${API_PATH_INTERNAL}/commercial-agreement-templates`

  async getAgreementTemplate(
    templatedAgreementId: number,
  ): Promise<CommercialAgreementTemplateItem> {
    const response = await apiService.get(
      `${this.endpoint}/${templatedAgreementId}`,
    )

    return response.data
  }
  async createPdfPreview(
    agreementTemplateId: number,
    request: CreateCommercialAgreementTemplatePdfPreviewRequest,
  ): Promise<Blob> {
    const response = await apiService.post<Blob>(
      `${this.endpoint}/${agreementTemplateId}/pdf-preview`,
      request,
      {
        responseType: 'blob',
      },
    )

    return response.data
  }

  async acceptAgreementTemplate(
    agreementTemplateId: number,
    request: AcceptCommercialAgreementTemplateRequest,
  ): Promise<Blob> {
    const response = await apiService.post(
      `${this.endpoint}/${agreementTemplateId}/accept-terms`,
      request,
    )

    return response.data
  }

  async requestAmendment(
    agreementTemplateId: number,
    request: AmendCommercialAgreementTemplateRequest,
  ): Promise<Blob> {
    const response = await apiService.post(
      `${this.endpoint}/${agreementTemplateId}/request-amendment`,
      request,
    )

    return response.data
  }

  async recordNoTerms(agreementTemplateId: number): Promise<unknown> {
    const response = await apiService.post(
      `${this.endpoint}/${agreementTemplateId}/record-no-terms`,
      {},
    )

    return response.data
  }
}

const commercialAgreementTemplateService =
  new CommercialAgreementTemplateService()

export default commercialAgreementTemplateService
